// @ts-check
import { Box, Button, Link, StarIcon } from '~/design-system';
import { Trans } from '@lingui/macro';
import { useCommonLinks } from '../../pages/imports/_config';
import Layout from '../Layout/Layout';
import PageSubtitle from '../Layout/PageSubtitle';
import PageTitle from '../Layout/PageTitle';
const PORTFOLIO_HOSTNAME = import.meta.env.VITE_PORTFOLIO_HOSTNAME;

/**
 * Renders the import complete page
 * @param {Object} props
 * @param {Object} [props.importData] - the import data
 */
export default function DefaultImportCompletePage({ importData }) {
  const link = useCommonLinks();
  const { collectionId } = importData;
  return (
    <Layout>
      <Box>
        <Box sx={{ textAlign: 'center' }}>
          <StarIcon sx={{ height: 120, width: '120px' }} />
          <PageTitle>
            <Trans>Import complete</Trans>
          </PageTitle>
          <PageSubtitle>
            <Trans>Your data was successfully imported.</Trans>
          </PageSubtitle>
          <Box sx={{ marginTop: 5 }}>
            <Button variant="primary" to={link.root()}>
              <Trans>View imports</Trans>
            </Button>
          </Box>
          <Box sx={{ marginTop: 3 }}>
            <Link
              href={`${PORTFOLIO_HOSTNAME}/dashboard/app/catalogs/${collectionId}/wines`}
              target="_blank"
            >
              <Trans>Go to collection</Trans>
            </Link>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
}
